export default "__VITE_ASSET__DK_wSLOP__"